import React from "react";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import "./SkeletonPlayerInformationSummary.css";

function SkeletonPlayerInformationSummary() {
  return (
    <section>
      <SkeletonTheme color="#6c757d" highlightColor="#495057">
        <ul className="list ">
              <li className="card bg-dark">
                <h4 className="card-title">
                  <Skeleton circle={true} height={60} width={60} /> &nbsp;
                  <Skeleton height={36} width={`90%`} />
                </h4>
                <div className="card-metrics">
                  <Skeleton height={60} width={`95%`} />
                </div>
              </li>
              <li className="boxes">
                  <div className="three-boxes">
                  <Skeleton width={100} height={40} /> &nbsp;
                  {/* <Skeleton width={100} height={40} /> &nbsp; */}
                  <Skeleton width={100} height={40} />
                  </div>
              </li>
              <li className="skeleton__container">
                  <div className="graph">
                      <Skeleton width={'90%'} height={500} />
                  </div>
                  <div className="graph">
                      <Skeleton width={'90%'} height={150} />
                  </div>
                  <div className="graph">
                      <Skeleton width={'90%'} height={150} />
                  </div>
              </li>
        </ul>
      </SkeletonTheme>
    </section>
  );
}

export default SkeletonPlayerInformationSummary;
